import i18n from '../i18n/i18n';

export default function notify(msg, type) {
  let dictionary = {
    'error': i18n.t('notify.error'),
    'success': i18n.t('notify.success')
  };

  setTimeout(() => {
    this.$notify({
      title: dictionary[type],
      message: msg,
      type
    });
  }, 500);
}
